import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getThumbnailUrl } from 'utils/BreakerImageAPI';
import styles from './AccountBreaker.module.scss';
import { DropdownAnchor } from '../Dropdown/DropdownAnchor';
import { BreakerSharing } from '../Sharing/ShareTargets';

type Props = {
  breaker: any;
  isSelected: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const AccountBreaker = ({ breaker, isSelected, onClick }: Props) => {
  const { token_id } = breaker;

  return (
    <div onClick={onClick} className={`chooseBreaker ${isSelected ? 'activeBreaker' : ''}`}>
      <LazyLoadImage
        key={token_id}
        src={getThumbnailUrl(token_id)}
        alt="Login"
        className="img-fluid"
      />
      <div className={styles.breakerInfo}>
        <p className="breakerName">{`DuskBreaker #${token_id}`}</p>
        <DropdownAnchor>
          <BreakerSharing
            breaker={{
              ...breaker,
              id: token_id,
            }}
          />
        </DropdownAnchor>
      </div>
    </div>
  );
};

export default AccountBreaker;
